export default __webpack_public_path__ + "static/media/PERFIL_GERENTE.f33921a1.png";